import { Injectable } from '@angular/core';
import { IApiRouteService } from '../../models/route';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { NtApiWorkOrder, NtApiWorkOrderPleats } from '../types/work-order';
import { ApiNsWorkOrderDto } from '../dto/work-order.dto';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiNtWorkOrderService extends IApiRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  protected urlRoute = environment.otherApis.netsuiteV2 + '/api/work-order';

  laboratory(): Observable<ApiNsWorkOrderDto['laboratory']['result']> {
    return this.http
      .get<ApiNsWorkOrderDto['laboratory']['result']>(
        `${this.urlRoute}/laboratory`
      )
      .pipe(
        map((res) =>
          res.map((item) => ({
            ...item,
            quantityAsked: +item.quantityAsked,
            quantityPacked: +item.quantityPacked,
          }))
        )
      );
  }

  information(id: number | string, query?: string): Observable<NtApiWorkOrder> {
    return this.http.get<NtApiWorkOrder>(
      `${this.urlRoute}/${id}/info${query ? `?${query}` : ''}`
    );
  }

  informationPleats(id: number | string): Observable<NtApiWorkOrderPleats> {
    return this.http.get<NtApiWorkOrderPleats>(
      `${this.urlRoute}/${id}/info/pleats`
    );
  }

  withSalesOrder(): Observable<ApiNsWorkOrderDto['withSalesOrder']['result']> {
    return this.http.get<ApiNsWorkOrderDto['withSalesOrder']['result']>(
      `${this.urlRoute}/with-so`
    );
  }

  getBom(id: string): Observable<ApiNsWorkOrderDto['bom']['result']> {
    return this.http.get<ApiNsWorkOrderDto['bom']['result']>(
      `${this.urlRoute}/${id}/bom`
    );
  }

  getLinesBom(id: string): Observable<ApiNsWorkOrderDto['bom']['result']> {
    return this.http.get<ApiNsWorkOrderDto['bom']['result']>(
      `${this.urlRoute}/${id}/lines-bom`
    );
  }
}
